export const EllipseIcon = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ cursor: 'default' }}
    >
      <rect width="40" height="40" rx="20" fill="white" />
      <circle cx="14" cy="20" r="2" fill="#DADDE0" />
      <circle cx="20" cy="20" r="2" fill="#DADDE0" />
      <circle cx="26" cy="20" r="2" fill="#DADDE0" />
    </svg>
  );
};
